import { HTTP_STATUS } from "components/constants";
import {
  CONFIGURATION_API,
  MERCHANT_DETAILS,
} from "components/constants/api-paths";
import {
  extraStatementList,
  extraTransactionList,
} from "components/constants/preference.c";
import { DATE_FORMATS_OPTIONS } from "pages/user-settings/date-format";
import { FILE_FORMATS_VALUES } from "pages/user-settings/file-format";
import {
  setAcquirersList,
  setDasmidOptions,
  setMerchantData,
  setMerchantsList,
  setPaymentLoggroup,
  setProductsList,
  setReasonCodeList,
  setSalesLeadFilterMerchant,
  setSalesLeadFilterPartner,
  setUserPreference,
} from "redux/features/gateway-config";
import { quickSort, transformChargebackReasonCode } from "./helper";
import { setIsV2Merchant } from "redux/features/auth";
import { CURRENCY_FORMATS_OPTIONS } from "pages/user-settings/currency-type";
import { ACCESS_GROUP_NAMES } from "components/constants/access-group-name";
import { startLoader, stopLoader } from "redux/features/loader";

const guestGroups = [
  ACCESS_GROUP_NAMES.GUEST,
  ACCESS_GROUP_NAMES.GUESTSCHEDULER,
  ACCESS_GROUP_NAMES.GUESTTHIRDPARTY,
];

const baseUrl = `${process.env.REACT_APP_API_URL}`;

export const fetchWithAuth = async (endpoint: string, token: string) => {
  const response = await fetch(`${baseUrl}/${endpoint}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_X_API_KEY || "",
      Authorization: token,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch ${endpoint}: ${response.statusText}`);
  }

  return await response.json();
};

export const getUserPreference = async (dispatch: any, idToken: string) => {
  const response = await fetchWithAuth("dasconfig/user-preferences", idToken);
  const hasValidPreferences =
    response?.data?.[0]?.configuration?.formatType &&
    response?.data?.[0]?.configuration?.transactionList?.list?.default &&
    response?.data?.[0]?.configuration?.statementList?.list?.default;

  if (hasValidPreferences) {
    const { configuration } = response.data[0];
    const { transactionList, statementList } = configuration;

    dispatch(
      setUserPreference({
        ...configuration,
        transactionList: {
          ...transactionList,
          list: { ...transactionList.list, ...extraTransactionList },
        },
        statementList: {
          ...statementList,
          list: { ...statementList.list, ...extraStatementList },
        },
      })
    );
  } else {
    dispatch(
      setUserPreference({
        transactionList: {
          selected: "default",
          list: {
            default: {
              order: [],
              unChecked: [],
            },
            ...extraTransactionList,
          },
        },
        statementList: {
          selected: "default",
          list: {
            default: {
              order: [],
              unChecked: [],
            },
            ...extraStatementList,
          },
        },
        dateFormatType: DATE_FORMATS_OPTIONS.DATE_TIME_AM_PM,
        formatType: FILE_FORMATS_VALUES.EXCEL,
        currencyType: CURRENCY_FORMATS_OPTIONS.USD,
      })
    );
  }
};

export const getDasMidOptions = async (
  dispatch: any,
  groups: any,
  accessLevel: any,
  idToken: string
) => {
  const logginInAsMerchant = groups?.includes("CUSTOMER");

  const response = await fetchWithAuth(CONFIGURATION_API, idToken);

  if ([HTTP_STATUS.OK]?.includes(response?.statusCode)) {
    const responseData = response?.data;
    const reasonCodeData = transformChargebackReasonCode(
      responseData?.chargebackReasonCode
    );
    dispatch(setReasonCodeList(reasonCodeData));
    const merchantData = responseData?.merchantData;
    const dasmidOptions = merchantData
      ? merchantData?.map(({ DASMID }: any) => DASMID)?.flat(1)
      : [];

    const dasmidList: any =
      dasmidOptions && dasmidOptions?.length > 0
        ? quickSort([...new Set(dasmidOptions)])
        : [];

    dispatch(setDasmidOptions(dasmidList));

    const v2DasmidOptions =
      merchantData
        ?.map(({ V2DASMID }: any) => V2DASMID)
        ?.flat(1)
        ?.filter((item: any) => item) || [];

    const IsV2Merchant = merchantData?.find((item: any) => item.IsV2Merchant);

    if (v2DasmidOptions?.length > 0 && IsV2Merchant) {
      if (logginInAsMerchant && accessLevel === "ADMIN") {
        dispatch(setIsV2Merchant(true));
      } else if (!logginInAsMerchant) {
        dispatch(setIsV2Merchant(true));
      } else {
        dispatch(setIsV2Merchant(false));
      }
    }

    const v2dasmidList: any =
      v2DasmidOptions && v2DasmidOptions?.length > 0
        ? [...new Set(v2DasmidOptions)]
        : "";

    localStorage.setItem("v2DasmidOptions", v2dasmidList);

    const acquirerCode: any = responseData?.acquirers;
    localStorage.setItem("acquirerCode", acquirerCode);

    const acquirerMIDData: any = quickSort(
      Object.values(responseData?.acquirerMIDData)?.flat(1)
    );
    localStorage.setItem("acquirerMIDData", acquirerMIDData);
    if (merchantData) dispatch(setMerchantData(merchantData));
    if (!logginInAsMerchant) {
      if (responseData?.configData?.payment_loggroup)
        dispatch(
          setPaymentLoggroup(responseData?.configData?.payment_loggroup)
        );

      const salesLeadData = responseData?.salesLeadData;
      if (salesLeadData?.Merchant)
        dispatch(setSalesLeadFilterMerchant(salesLeadData?.Merchant));
      if (salesLeadData?.Partner)
        dispatch(setSalesLeadFilterPartner(salesLeadData?.Partner));
    }

    return response;
  } else {
    localStorage.setItem("dasmidOptions", "");
    localStorage.setItem("v2DasmidOptions", "");
    return response;
  }
};

// export const handleAfterSignIn = async (
//   dispatch: any,
//   signInData: { token: { idToken: string }; Groups: any; accessLevel: any },
// ) => {
//   const idToken = signInData?.token?.idToken;
//   const groups = signInData?.Groups;
//   const accessLevel = signInData?.accessLevel;
//   if (!idToken) {
//     throw new Error('Authentication failed: No token received');
//   }

//   if (groups?.some((group: string) => guestGroups.includes(group))) {
//     return signInData;
//   }
//   try {
//     dispatch(startLoader());

//     await getUserPreference(dispatch, idToken);
//     if (!groups.includes('THIRDPARTY'))
//       await getDasMidOptions(dispatch, groups, accessLevel, idToken);

//     return signInData;
//   } finally {
//     dispatch(stopLoader());
//   }
// };

export const handleAfterSignIn = async (
  dispatch: any,
  signInData: { token: { idToken: string }; Groups: any; accessLevel: any }
) => {
  const idToken = signInData?.token?.idToken;
  const groups = signInData?.Groups;
  // const accessLevel = signInData?.accessLevel;

  const isCustomer = groups?.includes("CUSTOMER");
  try {
    dispatch(startLoader());
    const merchantList = MERCHANT_DETAILS.MERCHANT_LIST;
    const productList = MERCHANT_DETAILS.PRODUCT_DETAILS;
    const results = await Promise.allSettled([
      // restricting api call for acquirer and acquiere mid if its a customer
      isCustomer ? null : fetchWithAuth("acquirers/list-config", idToken),
      fetchAllPages(merchantList, idToken),
      fetchAllPages(productList, idToken),
    ]);

    // Destructure for readability
    const [acquirersResult, merchantResult, productResult] = results;

    // Example: extract only fulfilled values
    const acquirers =
      acquirersResult.status === "fulfilled" ? acquirersResult.value : null;
    const merchants =
      merchantResult.status === "fulfilled" ? merchantResult.value : null;
    const products =
      productResult.status === "fulfilled" ? productResult.value : null;

    acquirers && dispatch(setAcquirersList(acquirers?.data));
    merchants && dispatch(setMerchantsList(merchants));
    products && dispatch(setProductsList(products));

    return signInData;
  } finally {
    dispatch(stopLoader());
  }
};

// helper to fetch all pages of a paginated API
const fetchAllPages = async (
  endpoint: string,
  idToken: string,
  take: number = 50
) => {
  let allRecords: any[] = [];
  let skip = 0;
  let hasMore = true;

  while (hasMore) {
    const res: any = await fetchWithAuth(
      `${endpoint}?take=${take}&skip=${skip}`,
      idToken
    );

    const records = res?.data?.records ?? [];
    allRecords = [...allRecords, ...records];
    hasMore = allRecords.length < res?.data?.total_count;
    skip += take;
  }

  return allRecords;
};
